<template>
  <change-password-form :passwordChangeNeeded="false"/>
</template>

<script>
  // // @ is an alias to /src
  import ChangePasswordForm from '@/components/ChangePasswordForm'
  
  export default {
    components:{
      'change-password-form' : ChangePasswordForm
    },
    name: 'changePassword',
    props: ['existingPassword'],
    data () {
      return {
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>